import { CMS } from '../types/cms';

export function isDjangoEditMode(): boolean {
  const cms: CMS | undefined = (window as typeof window & { CMS?: CMS }).CMS;
  return cms?.config?.mode === 'draft' || cms?.config?.mode === 'edit';
}
